export type countryWiseDownload = {
    country: string;
    count: number | string;
};

export const countryWiseDownloads: countryWiseDownload[] = [
    {
        country: "Afghanistan",
        count: 3
    },
    {
        country: "Россия",
        count: 1
    },
    {
        country: "India",
        count: 7
    },
    {
        country: "United States",
        count: 6
    },
    {
        country: "France",
        count: 1
    },
    {
        country: "Singapore",
        count: 1
    },
    {
        country: "United Kingdom",
        count: 1
    },
    {
        country: "Egypt",
        count: 3
    },
    {
        country: "Saudi Arabia",
        count: 3
    },
    {
        country: "México",
        count: 1
    },
    {
        country: "Germany",
        count: 1
    },
    {
        country: "British Indian Ocean Territory",
        count: 1
    },
    {
        country: "Pakistan",
        count: 1
    }
];

export type recentlyDashboardPost = {
    id: string;
    userId: string;
    userPic: string;
    userName: string;
    date: string;
};

export const recentlyDashboardPosts: recentlyDashboardPost[] = [
    {
        id: "1",
        userId: "2",
        userPic:
            "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/17021226814932UWWDjndvg.jpg",
        userName: "Abdulaziz Al Khaldi",
        date: "May 08, 2024"
    },
    {
        id: "2",
        userId: "2",
        userPic:
            "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/17021226814932UWWDjndvg.jpg",
        userName: "Abdulaziz Al Khaldi",
        date: "May 08, 2024"
    },
    {
        id: "3",
        userId: "4",
        userPic:
            "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg",
        userName: "Richard Kettleboroug",
        date: "May 07, 2024"
    },
    {
        id: "4",
        userId: "3",
        userPic:
            "https://momeento.nyc3.digitaloceanspaces.com/images/1706690469_profile.jpg",
        userName: "Satish Chauhan",
        date: "May 06, 2024"
    },
    {
        id: "5",
        userId: "4",
        userPic:
            "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg",
        userName: "Richard Kettleboroug",
        date: "May 06, 2024"
    }
];

export type dashBoardNoti = {
    id: string;
    title: string;
    body: string;
    date: string;
    count: string | number;
};
export const dashBoardNotifications: dashBoardNoti[] = [
    {
        id: "1",
        title: "test",
        body: "testing the message",
        date: "March 10, 2024",
        count: 1
    },
    {
        id: "2",
        title: "Hello",
        body: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat incidunt magnam ducimus suscipit fugit voluptatem.",
        date: "March 10, 2024",
        count: 1
    },
    {
        id: "3",
        title: "New Update",
        body: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat incidunt magnam ducimus suscipit fugit voluptatem.",
        date: "March 9, 2024",
        count: 6
    },
    {
        id: "4",
        title: "Test",
        body: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat incidunt magnam ducimus suscipit fugit voluptatem.",
        date: "March 8, 2024",
        count: 1
    },
    {
        id: "5",
        title: "Another Test",
        body: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat incidunt magnam ducimus suscipit fugit voluptatem.",
        date: "March 6, 2024",
        count: 145
    },
    {
        id: "6",
        title: "Hello",
        body: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat incidunt magnam ducimus suscipit fugit voluptatem.",
        date: "March 5, 2024",
        count: 1
    },
    {
        id: "7",
        title: "Good Morning!",
        body: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat incidunt magnam ducimus suscipit fugit voluptatem.",
        date: "March 5, 2024",
        count: 1
    }
];
